
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/motorcycle-rental-insurance",
      function () {
        return require("private-next-pages/motorcycle-rental-insurance.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/motorcycle-rental-insurance"])
      });
    }
  